import * as types from '../mutation-types';

export const state = {
    //data
    searchString: null,
    searchObject: null,
};

export const getters = {
    // computed properties
    searchString: state => state.searchString,
};

export const actions = {
    // methods
    // make call
    // never update a state
    searchMessage({commit}, payload) {
        commit(types.SEARCH_MESSAGE, payload);
    },
};

export const mutations = {
    //setting and updating state
    [types.SEARCH_MESSAGE](state, message) {
        state.searchString = message;
    },
};
